import Vue from 'vue' //引入 Vue
import VueRouter from 'vue-router' //引入 Vue 路由
import MainVue from '../components/Menu';

Vue.use(VueRouter); //安装插件


export const constantRouterMap = [
    //配置默认的路径，默认显示主页
    { path: '/', redirect: '/xyd/welcome', component: () => import('@/views/welcome') },

    // 信易贷
    {
        path: '/xyd',
        component: MainVue,
        children: [
            //欢迎页
            {
                path: 'welcome',
                component: () => import('@/views/welcome')
            },
            //登录页
            {
                path: 'login',
                name: "login",
                component: () => import('@/views/login')
            },
            //主页
            {
                path: 'index',
                name: "xydindex",
                component: () => import('@/views/index')
            },
            // 防疫首页
            {
                path: 'fangyihome',
                name: "fangyihome",
                component: () => import('@/views/fangyi/fangyihome')
            },
            // 防疫产品页
            {
                path: 'fangyichanpin',
                name: "fangyichanpin",
                component: () => import('@/views/fangyi/chanpin')
            },
            // 数字人民币专区
            {
                path: 'numberyuan',
                name: "numberyuan",
                component: () => import('@/views/numberYuan/index')
            },
            // 特惠礼包
            {
                path: 'newyearbiggift',
                name: "newyearbiggift",
                component: () => import('@/views/fangyi/newyearbiggift')
            },
            //体系介绍
            {
                path: 'system_introduced',
                component: () => import('@/views/system_introduced/index')
            },
            //申请贷款
            {
                path: 'apply_loan',
                component: () => import('@/views/apply/apply_loan')
            },
            //申请贷款-成功
            {
                path: 'apply_success',
                component: () => import('@/views/apply/apply_success')
            },
            //申请贷款-成功
            {
                path: 'SzzxdApply',
                component: () => import('@/views/apply/suZhouBank')
            },
            {
                path: 'SznshApply',
                component: () => import('@/views/apply/SznshBank')
            },
            {
                path: 'sydApply',
                component: () => import('@/views/apply/suiyidaiinfo')
            },
            //贷款推荐
            {
                path: 'recommend_load',
                component: () => import('@/views/apply/recommend_load')
            },
            //产品详情
            {
                path: 'product_details',
                component: () => import('@/views/apply/productDetails')
            },
            //产品详情
            {
                path: 'product_list_details',
                component: () => import('@/views/apply/productDetailsList')
            },
            //产品超市
            {
                path: 'Supermarket',
                component: () => import('@/views/apply/Supermarket')
            },
            //政策指南
            {
                path: 'policy_guidelines',
                component: () => import('@/views/policy_guidelines/index')
            },
            //政策指南-详情
            {
                path: 'guide_detail',
                component: () => import('@/views/policy_guidelines/news')
            },
            //线上授权
            {
                path: 'onlineAuth',
                name: "onlineAuth",
                component: () => import('@/views/apply/onlineAuth')
            },
            //更多展示
            {
                path: 'moreShow',
                name: 'moreShow',
                component: () => import('@/views/apply/moreShow'),
            },
            {
                path: 'summList',
                component: () => import('@/views/apply/summList'),
            },
            // // 登录日志
            // {
            //     path: 'loginlog',
            //     component: () => import('@/views/loglist/Loginlog'),
            // },
            // {
            //     path: 'moreShow',
            //     component: () => import('@/views/apply/moreShow')
            // }

            //特色品牌
            // {
            //     path: 'brand_xy',
            //     component: () => import('@/views/brand/xy_care')
            // },
            // {
            //     path: 'brand_zx',
            //     component: () => import('@/views/brand/zx_care')
            // },
            // {
            //     path: 'brand_xb',
            //     component: () => import('@/views/brand/xb_care')
            // },
            // {
            //     path: 'brand_v',
            //     component: () => import('@/views/brand/v_care')
            // },
            // {
            //     path: 'brand_zc',
            //     component: () => import('@/views/brand/zc_care')
            // },
            // {
            //     path: 'brand_gz',
            //     component: () => import('@/views/brand/gz_care')
            // },

            //公共信用查询

            {
                path: 'publicCredit',
                component: () => import('@/views/creditService/publicCredit')
            },
            {
                path: 'creditDetails',
                component: () => import('@/views/creditService/creditDetails')
            },
            //信用共享
            {
                path: 'credit_share',
                component: () => import('@/views/credit_share/index')
            },
            //联系我们
            {
                path: 'contact',
                component: () => import('@/views/contact/contact')
            },
            // 个人中心
            {
                path: 'my_center',
                component: () => import('@/views/my_center/index')
            },
        ],
    },
    // {
    //     path: '/xyd/h5/productDetails',
    //     component: () => import('@/components/product/productDetails')
    // },
    // {
    //     path: '/xyd/h5/productList',
    //     component: () => import('@/components/product/productList')
    // }
]

export default new VueRouter({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap //指定路由列表
})
